import React from "react";
import { Box, Button } from "@mui/material";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";

function formatarData(valor) {
  if (!valor) return "-";
  const data = valor?.toDate?.() || new Date(valor);
  return Number.isNaN(data.getTime()) ? "-" : data.toLocaleDateString("pt-BR");
}

export default function RelatorioEquipamentos({ equipamentos, tipo, onVoltar }) {
  const envioCalibracao = tipo === "envio_calibracao";
  const linhasVazias = envioCalibracao
    ? Array.from({ length: Math.max(0, 10 - equipamentos.length) })
    : [];

  return (
    <Box className="relatorio-equipamentos-tela">
      <Box className="relatorio-equipamentos-acoes">
        <Button variant="outlined" onClick={onVoltar}>Voltar</Button>
        <Button variant="contained" onClick={() => window.print()}>Imprimir</Button>
      </Box>

      <section className="relatorio-equipamentos-pagina">
        {envioCalibracao ? (
          <>
            <table className="relatorio-envio-cabecalho">
              <tbody>
                <tr>
                  <td rowSpan="3" className="relatorio-envio-logo"><LogoRelatorio alt="Logo da empresa" /></td>
                  <th rowSpan="3">LISTA DE EQUIPAMENTOS PARA CALIBRAÇÃO</th>
                  <td>FORM 41</td>
                </tr>
                <tr><td>Revisão 00</td></tr>
                <tr><td>{new Date().toLocaleDateString("pt-BR")}</td></tr>
              </tbody>
            </table>
            <div className="relatorio-envio-dados">
              <div><span>EMPRESA:</span><strong>&nbsp;</strong></div>
              <div><span>ENDEREÇO:</span><strong>&nbsp;</strong></div>
            </div>
          </>
        ) : (
          <header className="relatorio-equipamentos-cabecalho">
            <div className="relatorio-equipamentos-logo"><LogoRelatorio alt="Logo da empresa" /></div>
            <div><strong>RELATÓRIO DE EQUIPAMENTOS</strong></div>
            <div>
              <span>Data</span>
              <strong>{new Date().toLocaleDateString("pt-BR")}</strong>
            </div>
          </header>
        )}

        {envioCalibracao ? (
          <table className="relatorio-equipamentos-tabela relatorio-envio-tabela">
            <colgroup>
              <col className="relatorio-envio-col-item" />
              <col className="relatorio-envio-col-descricao" />
              <col className="relatorio-envio-col-und" />
              <col className="relatorio-envio-col-qtd" />
              <col className="relatorio-envio-col-data" />
              <col className="relatorio-envio-col-data" />
              <col className="relatorio-envio-col-assinatura" />
              <col className="relatorio-envio-col-assinatura" />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan="2">ITEM</th>
                <th rowSpan="2">DESCRIÇÃO</th>
                <th rowSpan="2">UND</th>
                <th rowSpan="2">QTD</th>
                <th colSpan="2">DATA</th>
                <th colSpan="2">ASSINATURAS</th>
              </tr>
              <tr>
                <th>ENTREGA</th>
                <th>DEVOLUÇÃO</th>
                <th>RECEBIMENTO</th>
                <th>DEVOLUÇÃO</th>
              </tr>
            </thead>
            <tbody>
              {equipamentos.map((equipamento, index) => (
                <tr key={equipamento.id}>
                  <td>{index + 1}</td>
                  <td>{equipamento.nome}{equipamento.descricao ? ` - ${equipamento.descricao}` : ""}</td>
                  <td>UN</td><td>1</td><td></td><td></td><td></td><td></td>
                </tr>
              ))}
              {linhasVazias.map((_, index) => (
                <tr key={`linha-vazia-${index}`} className="relatorio-envio-linha-vazia">
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <table className="relatorio-equipamentos-tabela">
            <thead><tr><th>Equipamento</th><th>Descrição</th><th>Vencimento da calibração</th></tr></thead>
            <tbody>
              {equipamentos.map((equipamento) => (
                <tr key={equipamento.id}>
                  <td>{equipamento.nome || "-"}</td>
                  <td>{equipamento.descricao || "-"}</td>
                  <td>{formatarData(equipamento.certificado?.dataVencimento)}</td>
                </tr>
              ))}
              {!equipamentos.length && <tr><td colSpan="3">Nenhum equipamento encontrado para o filtro selecionado.</td></tr>}
            </tbody>
          </table>
        )}
      </section>

      <style>{`
        .relatorio-equipamentos-tela { background:#eef2f6; min-height:100vh; padding:20px; }
        .relatorio-equipamentos-acoes { display:flex; justify-content:flex-end; gap:12px; margin:0 auto 16px; max-width:1120px; }
        .relatorio-equipamentos-pagina { width:297mm; min-height:210mm; box-sizing:border-box; margin:auto; padding:10mm; background:#fff; color:#000; }
        .relatorio-equipamentos-cabecalho { display:grid; grid-template-columns:32mm 1fr 35mm; min-height:22mm; border:1px solid #000; align-items:stretch; }
        .relatorio-equipamentos-cabecalho > div { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:4px; text-align:center; border-right:1px solid #000; }
        .relatorio-equipamentos-cabecalho > div:last-child { border-right:0; }
        .relatorio-equipamentos-logo img { max-width:27mm; max-height:17mm; object-fit:contain; }
        .relatorio-envio-cabecalho { width:100%; border-collapse:collapse; table-layout:fixed; text-align:center; }
        .relatorio-envio-cabecalho td, .relatorio-envio-cabecalho th { border:1px solid #000; padding:4px; }
        .relatorio-envio-cabecalho td:first-child { width:32mm; }
        .relatorio-envio-cabecalho td:last-child { width:88mm; }
        .relatorio-envio-logo img { max-width:27mm; max-height:17mm; object-fit:contain; }
        .relatorio-envio-dados { display:grid; grid-template-columns:1fr 1.05fr; border-left:1px solid #000; }
        .relatorio-envio-dados > div { min-height:12mm; display:flex; flex-direction:column; border-right:1px solid #000; border-bottom:1px solid #000; padding:2px; }
        .relatorio-envio-dados span { font-size:12px; }
        .relatorio-equipamentos-tabela { width:100%; margin-top:6px; border-collapse:collapse; font-size:11px; }
        .relatorio-equipamentos-tabela th, .relatorio-equipamentos-tabela td { border:1px solid #000; padding:5px; }
        .relatorio-equipamentos-tabela th { text-align:center; }
        .relatorio-equipamentos-tabela td:first-child { text-align:center; }
        .relatorio-envio-tabela { margin-top:0; table-layout:fixed; }
        .relatorio-envio-tabela th, .relatorio-envio-tabela td { padding:3px; }
        .relatorio-envio-col-item { width:11mm; }
        .relatorio-envio-col-descricao { width:auto; }
        .relatorio-envio-col-und, .relatorio-envio-col-qtd { width:10mm; }
        .relatorio-envio-col-data { width:25mm; }
        .relatorio-envio-col-assinatura { width:42mm; }
        .relatorio-envio-tabela td:nth-child(2) { text-align:left; }
        .relatorio-envio-linha-vazia { height:9mm; }
        @media print {
          @page { size:A4 landscape; margin:0; }
          body * { visibility:hidden !important; }
          .relatorio-equipamentos-pagina, .relatorio-equipamentos-pagina * { visibility:visible !important; }
          .relatorio-equipamentos-tela { padding:0; background:#fff; }
          .relatorio-equipamentos-acoes { display:none !important; }
          .relatorio-equipamentos-pagina { position:absolute; left:0; top:0; margin:0; }
        }
      `}</style>
    </Box>
  );
}
